/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */

export class ApiService {
    constructor() { }

    getHeaders() {
        const headerJson = {};
        const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
        headerJson['Content-Type'] = 'application/json';

        // if (token) {
        //     headerJson['Authorization'] = 'Bearer ' + token;
        // }
        return headerJson;
    }

    options(method = 'GET') {
        return {
            method: method,
            headers: this.getHeaders()
        };
    }

    async get(url) {
        let res = await fetch(url, this.options());
        return this.parse(res);
    }

    async getAll(url) {
        let res = await fetch(url, this.options());
        return this.parse(res);
    }

    async post(url, model) {
        let options = {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(model)
        };
        let res = await fetch(url, options);
        return res ? res.json() : {};
    }

    async put(url, model) {
        let options = {
            method: 'PUT',
            headers: this.getHeaders(),
            body: JSON.stringify(model)
        };
        let res = await fetch(url, options);
        return res ? res.json() : {};
    }

    async delete(url) {
        let res = await fetch(url, this.options('DELETE'));
        return res.json();
    }

    async parse(res) {
        if (res.status >= 400 && res.status < 600) {
            this.handleException(res);
        }
        return res.json();
    }

    handleException(err) {
        // if (err.statusText === 'Unauthorized') {
        //     this.msg.error('Your session has been expired, please re-login.');
        //     // console.log();
        // } else {
        //     this.msg.error(err.statusText || 'Something went wrong while calling api.');
        //     // console.log(err.message || `Something went wrong while calling api.`);
        //     // return err.json();
        // }
    }
}
